<template>
    <v-layout justify-center>
    <v-card>
      <!--タイトル-->
        <v-card-title class="head title-center" style="display:block; text-align:center;">
        学術集会向け事前参加登録システム
        <!--タイトル横アイコン-->
        <v-icon
        color="black"
        class="ml-2 mt-1">
          {{ icon }}
        </v-icon>
      </v-card-title>
    <!--概要-->
    <Summary></Summary>
    <!--お問い合わせ-->
    <contact></contact>
    </v-card>
    </v-layout>
</template>

<style>
.title-center{
  justify-content: center;
}
</style>

<script>
import Summary from './Summary'
import contact from '../contact'

export default {
  data () {
    return {
      // タイトル
      title: '学術集会向け事前参加登録システム',
      // タイトル横のアイコン
      icon: 'mdi-account-check'
    }
  },
  components: {
    Summary,
    contact
  }
}
</script>
